import styled from "react-emotion";

const Styled = {
  Container: styled("div")`
    background: #0c0c0c;
    position: relative;
    padding: 0 0 0 2%;
    height: 100vh;
  `,
  VideoContainer: styled("div")`
    height: calc(100% - 70px);
    width: 67%;
    max-width: calc(100% - 350px);
    padding-top: 80px;
  `,
  Video: styled("video")`
    display: block;
    width: calc(100% - 10px);
    padding-right: 10px;
  `,
};

export default Styled;



// WEBPACK FOOTER //
// ./src/pages/tutorial/Styled.jsx